
import { StatusBar } from 'expo-status-bar';
import { useEffect, useState } from 'react';
import { Button, ScrollView, StyleSheet, Text, View, Image, useWindowDimensions } from 'react-native';
import WpApi from '../../../services/wpApi';
import HeaderFC from '../../Header/header';
import PostComponent from '../../Post/Post';
import PrincipalComponent from '../../PrincipalDaPAgina/Principal';
import RenderPosts from '../../RenderPosts/RenderPosts';
import LoadingComp from '../../Loading/loading';
import Footer from '../../Footer/footer';
import { GamesWidgets, StandingsWidgets } from '../../SoccerWidget/Soccerwidgets';

 const SulAmericano = ({navigation}:any) => {

  
  const {height, width} = useWindowDimensions();
  const [posts, setPosts] = useState<any>()
  const [loading, setLoading] = useState(true)
  const postsPerRequest= 5
  let api = new WpApi(setPosts, postsPerRequest);

  const styles = StyleSheet.create({
    container: {
      flex: 1,
      backgroundColor: '#fff',
      alignItems: 'center',
      justifyContent: 'center',
    },
    scrollView:{
      backgroundColor: "pink",
      height: "5%",
      width: "100%",
      alignItems:'center',
      position:'absolute',
      top: 0,
    },
    postContainer:{
      width:'100%',
      marginTop: "5%",
      flexDirection: width < 900 ? undefined :'row-reverse'
    }
  });

  useEffect(() => {
    api.getSpecificPosts('6').then(()=>{
      
      setLoading(false)})
  }, [])

  
  const renderPosts = () =>{
    let render: JSX.Element[] = []
    posts.map((element: any) => {
      render.push(<PostComponent key={element.id} props={element}></PostComponent>)
    })
    return render
  }

  if(loading && !posts){

    return(
      <LoadingComp pagenum={3}></LoadingComp>
    )
  }
  return (
    <View style={styles.container}>
      <HeaderFC pageNum={3}/>
      
      <View style={styles.scrollView}>
        
        <PrincipalComponent props={posts[0]}></PrincipalComponent> 
        <View style={{height: 350, width: '80%'}}>
            <GamesWidgets league='13' season='2023'></GamesWidgets>
          </View>
        <View style={styles.postContainer}>
          
          <View style={{height: 550,}}>
            <StandingsWidgets league='71' season='2023'></StandingsWidgets>
          </View>
            
          <RenderPosts setPosts={setPosts} posts={posts} api={api} postsPerRequest={postsPerRequest}></RenderPosts>
          
        </View>

        
        <Footer></Footer>
        {/* <Button
            onPress={() => {
                navigation.navigate('Noticia', {excerpt: posts[0].excerpt, title: posts[0].title, content: posts[0].content, image: posts[0].image})
            }}
            title="push me"
          /> */}
{/* 
        <Button
          onPress={() => {
            api.pullData()
          }}
          title="Dados"
        />
        <Button
          onPress={() => {
            api.searchTags()
          }}
          title="Dados"
        /> */}

        {/* <Button
          onPress={() => {
            console.log(posts)
          }}
          title="Post"
        /> */}
      </View>

      
        
      <StatusBar style="auto" />
    </View>
  );
}




export default SulAmericano;

